import tw, { css } from 'twin.macro'

export const bgPatternStyles = [tw`opacity-50 top-[55rem] w-[50rem] h-[50rem] lg:top-[70rem] 2xl:top-[50rem]`]

export const selectFilterContainerStyles = css`
  div > a > .flavor-button-spacer {
    ${tw`!hidden`}
  }

  /* Keeps the place holder link from being clicked, causing the page to refresh */
  button a {
    pointer-events: none;
  }
`
